// src/components/ForgotPassword.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/forgot-password', { email });
      setStatus('✅ If this email exists, a reset link has been sent.');
    } catch (err) {
      console.error('Forgot password error:', err);
      setStatus('⚠️ Something went wrong. Please try again later.');
    }
  };

  return (
    <div style={containerStyle}>
      <h2>🔐 Forgot Password</h2>
      <form onSubmit={onSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={inputStyle}
        />
        <button type="submit" style={buttonStyle}>Send Reset Link</button>
      </form>
      {status && <p style={{ marginTop: 16 }}>{status}</p>}
      <div style={{ marginTop: 20 }}>
        <Link to="/login" style={linkStyle}>← Back to Login</Link>
      </div>
    </div>
  );
}

const containerStyle = {
  maxWidth: 400,
  margin: '100px auto',
  padding: 20,
  textAlign: 'center',
  border: '1px solid #ddd',
  borderRadius: 8
};
const inputStyle = {
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  borderRadius: 6,
  border: '1px solid #ccc',
  marginBottom: 12
};
const buttonStyle = {
  width: '100%',
  padding: '12px',
  fontSize: '16px',
  backgroundColor: '#2C3E91',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer'
};
const linkStyle = {
  color: '#2C3E91',
  textDecoration: 'none',
  fontSize: 14
};